
<template><div ref="smallPopup" id="sidebarpopup" class="popup overlay smallerpopup"
               data-model="">
  <div ref="popup_wrapper__smaller" class="popup_wrapper popup_wrapper__smaller">
               <span @click="closeOverlay" class="popup_closepopup closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
    <span @click="nextStep('eventStep1')" class="popup_prevstep prevstep">
        <img style="transform: scaleX(-1);" src="@/assets/img/arrow-right.svg">
      </span>
    <div class="popup_content popup_content_right">
      <div v-show="showVideo" id="fullscreenvideo">
        <video controlsList="nodownload" ref="videoElement" @ended="videoEnded" :muted="isVolumeMuted" controls playsinline>
          <source v-if="videoData === 'bar'" :src="barWebmSrc" type="video/webm">
          <source v-if="videoData === 'bar'" :src="barMp4Src" type="video/mp4">
          <source v-if="videoData === 'kirmes'" :src="kirmesWebmSrc" type="video/webm">
          <source v-if="videoData === 'kirmes'" :src="kirmesMp4Src" type="video/mp4">
          <source v-if="videoData === 'konzert'" :src="konzertWebmSrc" type="video/webm">
          <source v-if="videoData === 'konzert'" :src="konzertMp4Src" type="video/mp4">
        </video>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import {useMediaStore} from "@/globalStorage";

export default {
  name:'EventStep2',
  props: {
    formData: {
      type: Object,
      required: true,
    },
    videoData: {
      type: String,
      default: "none",
    },
    isVolumeMuted: {},
  },
  watch: {
    videoData() {

      // Führe hier Code aus, wenn sich videoData ändert
    }
  },
  data() {
    return {
      showVideo: false,
      mediaStore: useMediaStore()
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    barWebmSrc() {
      return require(`@/assets/video/webspecial_event_bar_${this.locale}.webm`);
    },
    barMp4Src() {
      return require(`@/assets/video/webspecial_event_bar_${this.locale}.mp4`);
    },
    kirmesWebmSrc() {
      return require(`@/assets/video/webspecial_event_kirmes_${this.locale}.webm`);
    },
    kirmesMp4Src() {
      return require(`@/assets/video/webspecial_event_kirmes_${this.locale}.mp4`);
    },
    konzertWebmSrc() {
      return require(`@/assets/video/webspecial_event_konzert_${this.locale}.webm`);
    },
    konzertMp4Src() {
      return require(`@/assets/video/webspecial_event_konzert_${this.locale}.mp4`);
    }
  },
  mounted() {
    this.initView();
  },
  beforeMount() {
    this.$emit('goBack','eventStep1');
  },
  methods: {
    initView() {
      this.showVideo = true; // Video-Container einblenden
      this.$refs.videoElement.play(); // Video abspielen
      this.playVideo()
    },
    playVideo() {
      this.mediaStore.playVideo();
    },
    stopVideo() {
      this.mediaStore.stopVideo();
    },
    videoEnded() {
      this.stopVideo();
      this.$emit('nextStep','outro');
    },
    closeOverlay() {
      this.$emit('closeOverlay')
    },
    nextStep(data) {
      this.$emit('nextStep',data)
    }
  },
};
</script>
<style lang="scss" scoped>

$yellow: #FDBE1F;
$mainblue: #015672;
.popup_prevstep {
  background: $yellow;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  position: absolute;
  left: 35px;
  top: 35px;
  border-radius: 10px;
  transition: 0.3s;
  box-sizing: border-box;
  border: 3px solid $yellow;
  z-index: 2;

  @media screen and (max-width: 640px) {
    right: 15px;
    left:15px;
    width: 40px;
    height: 40px;
    top:26px;
  }
  &:hover {
    background:#ffffff;
    cursor:pointer;
  }
}
.closeoverlay {
  padding: 10px;
  background: $mainblue;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 35px;
  top: 35px;
  border-radius: 10px;
  transition: 0.3s;
  box-sizing: border-box;
  z-index: 2;

  svg {
    width: 80%;
    height: auto;
  }

  &:hover {
    cursor: pointer;
    background: $yellow;
  }

  @media screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 35px;
    top: 26px;
  }
  @media screen and (max-width: 640px) {
    right: 15px;
  }
}

.popup_wrapper__smaller:has(video) {
  padding: 5px !important;
  @media screen and (max-width:640px) {
    padding-top:70px !important;
  }
}


#fullscreenvideo {
  display:block;
  position:relative;
  width:100%;
  height:auto;
  z-index:1;
  overflow:hidden;
  border-radius:20px;
  video {
    object-position: center;
    height:auto;
    width:auto;
    max-height:70vh;
    max-width: 100%;
    min-height:70vh;
    display:block;
    object-fit: contain;

    @media screen and (max-width: 1366px) {
      min-height:1px;
    }
    @media screen and (max-width: 1024px) {
      width:100vw;
    }
  }
}
</style>
